module.exports = __webpack_public_path__ + "static/media/ads.1e066367.png";